// storybook-check-ignore
import React from 'react';

import { Button } from '@opendoor/bricks/core';

export const SkipLink: React.FC = (_props) => {
  return (
    <Button
      border={0}
      color="brand50"
      justifyContent="center"
      left={0}
      outline={0}
      position="fixed"
      top="0"
      transform="translateY(-100%)"
      width="100%"
      zIndex={1}
      display="flex"
      backgroundColor="neutrals0"
      aria-label="Skip navigation menu and view main content"
      _focus={{
        transform: 'translateY(0)',
      }}
      analyticsName="cosmos-landing-page-v2-skip-to-main-content"
      onClick={() => {
        const mainElem = document.querySelector('main');
        mainElem && mainElem.focus();
      }}
    >
      Skip to main content
    </Button>
  );
};
